import React from "react";
import { Helmet } from "react-helmet";

const VahanfinMeta = () => {
  return (
    <>
      <Helmet>
        <meta name="description" content="Hypothecation Management Portal Powered by Vahanfin." />
        <link rel="icon" type="image/png" href="https://vahanfin.com/vahanicon.png"/>

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.vahanfin.com/" />
        <meta property="og:title" content="Hypothecation Management Portal Powered by Vahanfin" />
        <meta property="og:description" content="Hypothecation Management Portal Powered by Vahanfin." />
        <meta property="og:image" content="https://www.vahanfin.com/poster.png" />

        {/* Twitter Card */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.vahanfin.com/" />
        <meta property="twitter:title" content="Hypothecation Management Portal Powered by Vahanfin" />
        <meta property="twitter:description" content="Hypothecation Management Portal Powered by Vahanfin" />
        <meta property="twitter:image" content="https://www.vahanfin.com/poster.png" />
        
        <title>Hypothecation Management Portal Powered by Vahanfin</title>
      </Helmet>
    </>
  );
};

export default VahanfinMeta;
